import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/special_subject_add_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-198660fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cabinet_base_info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add_tips" }, "点击创建卡柜", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "cabinet_info_list"
}
const _hoisted_6 = { class: "top_action_bg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_title" }, "预览", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_title" }, "编辑", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_title" }, "删除", -1))
const _hoisted_13 = { class: "bottom_content_view" }
const _hoisted_14 = { class: "cabinet_name_bg" }
const _hoisted_15 = { class: "show_switch" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否在H5展示", -1))
const _hoisted_17 = {
  key: 2,
  class: "special_subject_bg"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "top_action_bg" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_title" }, "编辑", -1))
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action_title" }, "删除", -1))
const _hoisted_24 = { class: "special_subject_name_bg" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "add_tips" }, "点击添加专题", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_SpecialSubjectAddView = _resolveComponent("SpecialSubjectAddView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.canbinetViewType == 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "add_cabinet_button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCabinetClick && _ctx.addCabinetClick(...args)))
        }, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.canbinetViewType == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinetInfoList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "cabinet_info_save_bg",
              style: _normalizeStyle({ backgroundImage: `url(${_ctx.cabinet_info_bg})` })
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  class: "action_button",
                  onClick: ($event: any) => (_ctx.previewCabinetClick(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.cabinet_share_icon,
                      alt: ""
                    }, null, 8, _hoisted_7),
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "action_button",
                  onClick: ($event: any) => (_ctx.editCabinetClick(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.cabinet_edit_icon,
                      alt: ""
                    }, null, 8, _hoisted_9),
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "action_button",
                  onClick: ($event: any) => (_ctx.deleteCabinetClick(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.cabinet_delete_icon,
                      alt: ""
                    }, null, 8, _hoisted_11),
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入卡柜名称",
                    modelValue: item.cabinetName,
                    "onUpdate:modelValue": ($event: any) => ((item.cabinetName) = $event),
                    maxlength: "12",
                    onChange: ($event: any) => (_ctx.cabinetNameChange(index))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_switch, {
                    width: "80",
                    onChange: ($event: any) => (_ctx.cabinetOpenSwitchChange(index)),
                    class: "public_switch",
                    modelValue: item.isOpen,
                    "onUpdate:modelValue": ($event: any) => ((item.isOpen) = $event),
                    "active-color": "rgb(0,0,0,0)",
                    "inactive-color": "rgb(0,0,0,0)"
                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                ])
              ])
            ], 4))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_ctx.canbinetViewType == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_BackButtonItem, {
            onBackBtnClick: _ctx.backButtonClick,
            class: "back_button"
          }, null, 8, ["onBackBtnClick"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialTopicList, (specialItem, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              class: "special_subject_info"
            }, [
              _createElementVNode("img", {
                class: "special_subject_img",
                src: specialItem.url,
                alt: ""
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_button, {
                  class: "action_button",
                  onClick: ($event: any) => (_ctx.specialSubjectInfoClick(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.cabinet_edit_icon,
                      alt: ""
                    }, null, 8, _hoisted_20),
                    _hoisted_21
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "action_button",
                  onClick: ($event: any) => (_ctx.deleteSpecialSubjectButton(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.cabinet_delete_icon,
                      alt: ""
                    }, null, 8, _hoisted_22),
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_input, {
                  placeholder: "请输入专题名称",
                  modelValue: specialItem.name,
                  "onUpdate:modelValue": ($event: any) => ((specialItem.name) = $event),
                  maxlength: "12",
                  onChange: ($event: any) => (_ctx.specialSubjectNameChange(index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ])
            ]))
          }), 128)),
          (_ctx.specialTopicList.length < 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "add_button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addSpecialSubjectClick && _ctx.addSpecialSubjectClick(...args)))
              }, _hoisted_27))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSpecialSubjectView)
      ? (_openBlock(), _createBlock(_component_SpecialSubjectAddView, {
          key: 3,
          currentSpecialTopicId: _ctx.currentSpecialTopicId,
          cabinetId: _ctx.currentCabinetId,
          onDismissSpecialSubject: _ctx.dismissSpecialSubjectView
        }, null, 8, ["currentSpecialTopicId", "cabinetId", "onDismissSpecialSubject"]))
      : _createCommentVNode("", true)
  ]))
}